import { useEffect, useState } from 'react';

/** True once the mouse, touch and keyboard were still for `ms` while `active`; any movement makes it false again. */
export function useIdle(active: boolean, ms: number) {
  const [idle, setIdle] = useState(false);
  useEffect(() => {
    if (!active) {
      setIdle(false);
      return;
    }
    let timer = 0;
    const wake = () => {
      setIdle(false); // same value: React bails out, no re-render per mouse move
      window.clearTimeout(timer);
      timer = window.setTimeout(() => setIdle(true), ms);
    };
    wake();
    const events = ['pointermove', 'pointerdown', 'keydown', 'wheel'] as const;
    for (const e of events) window.addEventListener(e, wake, { passive: true, capture: true });
    return () => {
      window.clearTimeout(timer);
      for (const e of events) window.removeEventListener(e, wake, { capture: true });
    };
  }, [active, ms]);
  return idle;
}
